"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentToExchangeImageSchema = void 0;
const zod_1 = require("zod");
const ContentItemDTO_1 = require("./ContentItemDTO");
const ContentToExchangeImageSchema = zod_1.z.object({
    content: ContentItemDTO_1.ContentItemPostDTOSchema,
    file: zod_1.z.any(),
});
exports.ContentToExchangeImageSchema = ContentToExchangeImageSchema;
